<template>
  <div class="topBtn">
    <div
      v-for="(item,index) in menusList"
      :key="index"
      class="topBtnItem rightBorder"
      :class="multilevelMenuId==item.meta.menuId?'activeItem':''"
      :style="{paddingLeft: index===0?'0':'16px'}"
      @click="clickHandle(item)">
      <a-icon class="menuIcon" v-if="(typeof item.meta.icon == 'object')" slot="prefix" :component="item.meta.icon" style="font-size: 18px;margin-right: 10px;"/>
      <a-icon class="menuIcon" v-else slot="prefix" :type="item.meta.icon" style="font-size: 18px;margin-right: 10px;"/>
      <span class="font20B" style="flex-shrink: 0;">{{ $t(item?.meta?.title) }}</span>
    </div>
  </div>
</template>
<script>
import defaultSettings from '@/config/defaultSettings'

export default {
  props: {
    menus: {
      type: Array,
      require: true,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      defaultSettings
    }
  },
  computed: {
    menusList() {
      const list = []
      this.menus.forEach(item => {
        if (!item.hidden) {
          list.push(item)
        }
      })
      console.log('list>>>>', list)

      return list
    }
  },
  methods: {
    toNext(path) {
      if (path === 'not') {
        this.$message.error('目前暂未开放')
      } else {
        this.$router.push({ path: path }).catch(() => { })
      }
    },
    /**
     * @desc 点击一级菜单
     * @param {  }
     * @version: 1.0.0
     */
    clickHandle(item) {
      console.log('点击一级菜单>>>>>>>>>', item)
      console.log('$route>>>>>点击一级菜单>>>>>>>>>', this.$route)
      console.log('$route>>>>>点击一级菜单>>>>>>>>indexOf>>>>>>', this.$route.path.indexOf(item.path))

      // if (this.$route.path.indexOf(item.path) === -1) {
      //   if (item.children && item.children.length > 0) {
      //     this.$router.push({ path: item.path }).catch(() => { })
      //   } else {
      //     this.$router.push({ path: item.path }).catch(() => { })
      //     if (!this.menuHidden) {
      //       this.$store.dispatch('setMenuHidden', true)
      //     }
      //   }
      // }
      this.$store.dispatch('setMultilevelMenuId', item.meta.menuId)
      console.log('>>>>>>>>>>>>>>', this.multilevelMenuId)
      let nextPath = item.path
      console.log('>>>>>>>>>>>>>>', nextPath)
      if (nextPath.indexOf('https://') !== -1 || nextPath.indexOf('http://') !== -1) {
        window.open(nextPath)
        return
      }
      if (item.path.indexOf('/') !== 0) {
        nextPath = '/' + item.path
      }
      if (nextPath !== this.$route.path) {
        if (item.children && item.children.length > 0) {
          this.$store.dispatch('setMenuHidden', false)
          // this.$router.push({ path: nextPath }).catch(() => { })
        } else {
          this.$router.push({ path: nextPath }).catch(() => { })
          if (!this.menuHidden) {
            this.$store.dispatch('setMenuHidden', true)
          }
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
.topBtn {
  width:100%;
  display: flex;
  height: 60px;
  width: auto;
  margin-right: auto;
  overflow-x:auto;
  // margin-left: 10px;
  // margin-right: 10px;

  .topBtnItem {
    position: relative;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    height: 100%;
    cursor: pointer;
    // border-right: 2px solid #2878FF;;
    padding:0 32px;

    &.rightBorder::after {
      content: "";
      position: absolute;
      right: 0;
      width: 0px;
      height: 21px;
      opacity: 1;
      border: 2px solid #333;
      border-radius: 10px;

    }

    &:last-child::after {
      content: "";
      position: absolute;
      right: 0;
      width: 0px;
      height: 0;
      opacity: 1;
      border: 0 solid #333;
      border-radius: 10px;

    }

    img {
      // width: 22px;
      height: 22px;
      margin-right: 10px;
    }

    span {
      font-size: 20px;
      color: #333;
    }

  }

  .activeItem {
    span {
      font-size: 20px;
      color: #2878FF;
    }

    .menuIcon {
      color: #2878FF;
    }

    &.rightBorder::after {
      content: "";
      position: absolute;
      right: 0;
      width: 0px;
      height: 21px;
      opacity: 1;
      border: 2px solid #2878FF;
      border-radius: 10px;

    }

    &:last-child::after {
      content: "";
      position: absolute;
      right: 0;
      width: 0px;
      height: 0;
      opacity: 1;
      border: 0 solid #2878FF;
      border-radius: 10px;

    }
  }

}
</style>
